import React, { useState, useEffect, useRef } from 'react';
import './VideoBanner.css';
import api from '../services/api'; // Corrigido o caminho do import para estar dentro do src

const VideoBanner = () => {
  const [banner, setBanner] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        // Usando o proxy configurado no package.json
        const response = await api.get('/get_active_banner.php'); // Usar a instância api
        const data = response.data; // axios já parseia o JSON e o coloca em response.data
        if (data.error) {
          throw new Error(data.error);
        }
        setBanner(data.banner);
      } catch (e) {
        console.error("Erro ao buscar banner:", e);
        setError(e.message);
        
        // Fallback para um banner estático em caso de erro
        setBanner({
          id: 1,
          title: "Promoção Especial",
          description: "Confira nossos produtos com descontos incríveis!",
          image_path: "/videos/maquiagem.mp4", // Usando o vídeo que já existia antes
          link_url: "",
          is_active: true
        });
      } finally {
        setLoading(false);
      }
    };

    fetchBanner();
  }, []);

  useEffect(() => {
    if (videoRef.current && banner && banner.image_path && banner.image_path.endsWith('.mp4')) {
      videoRef.current.load(); // Garante que o novo source seja carregado
      videoRef.current.play().catch(err => {
        console.error('Erro ao iniciar vídeo do banner:', err);
      });
    }
  }, [banner]);

  if (loading) {
    return <div className="video-banner-loading">Carregando banner...</div>;
  }

  if (error) {
    // Não renderiza nada ou um placeholder discreto em caso de erro para não quebrar o layout
    console.warn('Falha ao carregar o banner:', error)
    return null; 
  }

  if (!banner || !banner.image_path) {
    // Não renderiza nada se não houver banner ativo ou imagem
    return null;
  }

  const isVideo = banner.image_path.endsWith('.mp4');
  // A API retorna image_path como 'uploads/banners/arquivo.ext'
  // Precisamos prefixar com a URL base do seu site.
  // A API retorna image_path como 'uploads/banners/arquivo.ext' ou 'videos/arquivo.mp4'
  // Em produção, o caminho será relativo à raiz do site.
  // Em desenvolvimento, se os arquivos estiverem na pasta public, também será relativo à raiz.
  let mediaUrl = `/${banner.image_path.startsWith('/') ? banner.image_path.substring(1) : banner.image_path}`;
  if (process.env.NODE_ENV === 'development') {
    mediaUrl = `http://localhost:8080/catalogo${mediaUrl.startsWith('/') ? mediaUrl : '/' + mediaUrl}`;
  }

  const BannerMedia = () => {
    if (isVideo) {
      return (
        <video
          ref={videoRef}
          className="banner-video"
          autoPlay
          loop
          muted
          playsInline
          disablePictureInPicture
          controlsList="nodownload nofullscreen noremoteplayback"
          key={mediaUrl} // Key para forçar remount se a URL do vídeo mudar
        >
          <source src={mediaUrl} type="video/mp4" />
          Seu navegador não suporta o elemento de vídeo.
        </video>
      );
    } else {
      return (
        <img src={mediaUrl} alt={banner.title || 'Banner Promocional'} className="banner-image" />
      );
    }
  };

  const bannerContent = (
    <div className={`banner-media-container ${isVideo ? 'video-container' : 'image-container'}`}>
      <BannerMedia />
      {(banner.title || banner.description) && (
        <div className="banner-overlay-content">
          {banner.title && <h2 className="banner-title">{banner.title}</h2>}
          {banner.description && <p className="banner-description">{banner.description}</p>}
        </div>
      )}
    </div>
  );

  return (
    <div className="video-banner">
      {banner.link_url ? (
        <a href={banner.link_url} target="_blank" rel="noopener noreferrer" aria-label={banner.title || 'Link do Banner'}>
          {bannerContent}
        </a>
      ) : (
        bannerContent
      )}
    </div>
  );
};

export default VideoBanner;
